const dev = {
	API_ENDPOINT_URL: 'https://localhost:8000/v1/',
	IMG_SRC: 'https://localhost:8000',
	NOVU_APP_ID: '3cmYGNvYLx_S',
	WEB_SOCKET_URL: 'ws://127.0.0.1:8080'
};

const prod = {
	API_ENDPOINT_URL: 'https://api.tunimobile.com/v1/',
	IMG_SRC: 'https://api.tunimobile.com',
	NOVU_APP_ID: 'gIJdfzDMyVEF',
	WEB_SOCKET_URL: 'wss://api.tunimobile.com/ws'
};

const staging = {
	API_ENDPOINT_URL: 'https://apitest.tunimobile.com/v1/',
	IMG_SRC: 'https://apitest.tunimobile.com',
	NOVU_APP_ID: 'gIJdfzDMyVEF',
	WEB_SOCKET_URL: 'wss://apitest.tunimobile.com/ws'
};


const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case "development":
			return dev;
		case "production":
			return prod;
		case "staging":
			return staging;
		default:
			break;
	}
};

export const env = getEnv();
